import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Dropzone from "common/components/Dropzone"
import notification from "common/utils/notification"
import { useTranslation } from "react-i18next"
import "./styles.scss"

const ArchivosAdjuntosDropzone = ({
  handleUpload,
  maxFiles,
  multiple,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const mensajeError = (error: $TSMigrationFixMe) => {
    if (error[0]?.errors[0].code === "too-many-files") {
      notification.errorServidor({
        body: `${t("mayor.msg.onlyUpOne")}`,
      })

      return
    }
    notification.errorServidor({
      body: `${t("mayor.msg.probUpArch")}`,
    })
  }
  return (
    <Dropzone
      maxSize='4097152'
      maxFiles={maxFiles}
      onDropAccepted={handleUpload}
      onDropRejected={mensajeError}
      multiple={multiple}
    >
      <span className='dropzone-container-archivos-adjuntos tw-cursor-pointer !tw-bg-neutral-10 hover:!tw-bg-neutral-25'>
        <FontAwesomeIcon icon={["fal", "paperclip"]} />

        <span className='ml-2'>{t("diario.modal.attachArchLabel")}</span>
      </span>
    </Dropzone>
  )
}

export default ArchivosAdjuntosDropzone
